export default function reducer(
  state = {
    savedMediaPlan: '',
  },
  action
) {
  switch (action.type) {
    case 'SAVE_MEDIA_PLAN_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'SAVE_MEDIA_PLAN_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        savedMediaPlan: action.payload,
      };
    }
    case 'SAVE_MEDIA_PLAN_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        savedMediaPlan: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
